import { useEffect, useRef, useState } from "react";
import { Fade, Slide, Grow, Zoom } from "@mui/material";

const AnimateOnScroll = ({
  children,
  style,
  type = "fade",
  direction = "up",
  timeout = 300,
  triggerOnce = true,
  threshold = 0.2,
  className = "",
}) => {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (triggerOnce) observer.disconnect();
        } else if (!triggerOnce) {
          setVisible(false);
        }
      },
      { threshold }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [triggerOnce, threshold]);

  const animationProps = {
    in: visible,
    timeout,
    ...(type === "slide" ? { direction } : {}),
  };

  const generalStyle = { 
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <div ref={ref} style={style} className={className} >
      {type === "fade" && <Fade {...animationProps}><div style={generalStyle}>{children}</div></Fade>}
      {type === "slide" && <Slide {...animationProps}><div style={generalStyle}>{children}</div></Slide>}
      {type === "grow" && <Grow {...animationProps}><div style={generalStyle}>{children}</div></Grow>}
      {type === "zoom" && <Zoom {...animationProps}><div style={generalStyle}>{children}</div></Zoom>}
    </div>
  );
};

export default AnimateOnScroll;
